import React, { Component, Fragment } from "react";

// Page Mentions Légales (article 6.III de la LCEN — loi n° 2004-575 du 21 juin 2004)
class MentionsLegales extends Component {
  // Les liens étant en pied de page, on remonte en haut à l'ouverture de la page
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Fragment>
        <div className="page-title">
          <div className="container">
            <h1>Mentions Légales</h1>
          </div>
        </div>
        <div className="white-box inner-section">
          <div className="container">
            <section className="post mb35">
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Conformément aux dispositions de l'article 6 de la loi n° 2004-575 du 21 juin
                  2004 pour la confiance dans l'économie numérique (LCEN), il est porté à la
                  connaissance des utilisateurs du site <strong>cinevauban.fr</strong> les
                  présentes mentions légales.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Éditeur du site</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Le site <strong>cinevauban.fr</strong> est édité par :<br />
                  <strong>CINEVAUBAN</strong><br />
                  Forme juridique : Société par actions simplifiée (SAS)<br />
                  Capital social : 100 000,00 €<br />
                  Siège social : 45 rue de la Croix Désilles, 35400 Saint-Malo<br />
                  SIRET : 838 697 449 000 26 — RCS Saint-Malo 838 697 449<br />
                  Numéro de TVA intracommunautaire : FR47 838 697 449<br />
                  Email : sgenouvrier@cinevauban.fr
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Directeur de la publication</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Le directeur de la publication du site est M. Frémont, en sa qualité de
                  représentant légal de la société CINEVAUBAN.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Hébergeur</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Le site est hébergé par :<br />
                  <strong>Infomaniak Network SA</strong><br />
                  Rue Eugène-Marziano 25<br />
                  1227 Les Acacias (Genève) — Suisse<br />
                  Téléphone : +41 22 820 35 44<br />
                  Site web : www.infomaniak.com
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Objet du site</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Le site cinevauban.fr a pour objet de présenter au public la programmation,
                  les séances, les évènements, les tarifs et les informations pratiques des
                  cinémas exploités par la société CINEVAUBAN à Saint-Malo, et de permettre
                  aux utilisateurs de la contacter. La vente de billets et d'abonnements en
                  ligne est assurée via le service ws.cinevauban.fr.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Propriété intellectuelle</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  L'ensemble des éléments composant le site cinevauban.fr (textes, images,
                  logos, marques, affiches, photographies, vidéos, bandes-annonces, éléments
                  graphiques, structure et code) est protégé par le droit d'auteur, le droit
                  des marques et, plus largement, par le droit de la propriété intellectuelle.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  Toute reproduction, représentation, modification, publication, adaptation ou
                  exploitation, totale ou partielle, de ces éléments, par quelque procédé que
                  ce soit et sur quelque support que ce soit, sans l'autorisation écrite
                  préalable de la société CINEVAUBAN, est interdite et constitue une
                  contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la
                  propriété intellectuelle. Certaines affiches et bandes-annonces demeurent la
                  propriété de leurs ayants droit respectifs (distributeurs, producteurs).
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Liens hypertextes</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Le site peut contenir des liens hypertextes vers d'autres sites (réseaux
                  sociaux, partenaires, distributeurs). La société CINEVAUBAN n'exerce aucun
                  contrôle sur ces sites tiers et décline toute responsabilité quant à leur
                  contenu ou à l'usage qui pourrait en être fait. La création d'un lien vers
                  le site cinevauban.fr est soumise à l'autorisation préalable de l'éditeur.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Limitation de responsabilité</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  La société CINEVAUBAN s'efforce d'assurer l'exactitude et la mise à jour des
                  informations diffusées sur le site (programmation, horaires, tarifs), mais ne
                  saurait garantir l'absence d'erreurs ou d'omissions. Les informations sont
                  fournies à titre indicatif et sont susceptibles d'évoluer ; seules les
                  informations communiquées en caisse font foi.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  La société CINEVAUBAN ne saurait être tenue responsable des dommages directs
                  ou indirects résultant de l'accès au site ou de son utilisation, ni d'une
                  éventuelle indisponibilité temporaire du service.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Données personnelles et cookies</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Les traitements de données à caractère personnel mis en œuvre sur ce site,
                  ainsi que l'utilisation des cookies, sont détaillés dans notre{" "}
                  <a href="/Confidentialite">Politique de confidentialité</a>.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Droit applicable</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Les présentes mentions légales sont régies par le droit français. En cas de
                  litige et à défaut de résolution amiable, compétence est attribuée aux
                  tribunaux français compétents.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Réalisation</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Conception et réalisation du site : <strong>1000 MONDES</strong>.
                </p>
              </div>
            </section>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MentionsLegales;
